import { Component } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { NmDatatableSettings } from '../../../../widgets/datatable/datatable.interface';
import { HelperService } from '../../../../services/helper.service';

import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { DataService } from '../../../../services/data.service';
import { FormService } from '../../../../services/form.service';
import { NmDetailPageClass } from '../../../../shared/nm-detail-page-class';

import { ApiService } from '../../../../services/api.service';

declare let $: any;
declare let bootbox: any;

@Component({
	selector: 'email-tpls-list-page',
	templateUrl: './list.html',
	styleUrls: ['./list.css']
})
export class EmailTplsListPage {
	public modelName: string = 'emailtpl';
	public reloadTable: boolean = false;
	

	public constructor(
		private helper: HelperService,
		public formBuilder: FormBuilder,

		public data: DataService,

		private api: ApiService,
		private router: Router,
		private location: Location,
		private activatedRoute: ActivatedRoute
	) {}

	public ngOnInit() {
		if(!this.modelName) console.error('Missing modelName.');

		this.onBeforeRendered();
		
		
	}
	public onBeforeRendered() {
		/*let control = <FormArray>this.form.get('_contact_channels');
		for(let channel of this.data.shared.communicationChannels.getValue()) {
			control.push(this.formBuilder.control(false));
		}*/

	}



	public datatableSetting: NmDatatableSettings = {
		modelName: 'emailtpl',
		fields: [
			{ name: 'name', label: 'Key name', sortable: true, searchable: true,search: '' },
			{ name: 'locale', label: 'Locale', sortable: true, searchable: true, },
			{ name: 'subject', label: 'Subject', sortable: false, searchable: true, },
			{ name: 'sender_name', label: 'Sender Name', sortable: false, searchable: false, },
			{ name: 'sender_address', label: 'Sender Address', sortable: false, searchable: false, },
			
			
		],
		actions: [
			{ name: 'view', icon: 'search-plus', color: 'blue', show: () => true,
				callback: function(id, data) { this.router.navigate([`/email-tpls/view/${id}`]); }
			},
			{ name: 'edit', icon: 'pencil', color: 'green', show: () => true,
				callback: function(id, data) { this.router.navigate([`/email-tpls/edit/${id}`]); }
			},
			{ name: 'delete', icon: 'trash', color: 'red', show: () => true },
		],
		ajax: {
			url: 'emailtpl/datatables'
		},
		ajaxDataMassage: (data: any[]) => {
			
			return data.map(v => {
				
				

				return v;
			})
		}
	};
}



// WEBPACK FOOTER //
// ./src/pages/configs/email-tpls/list/list.ts